
var guid = function() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random()*16|0, v = c === 'x' ? r : (r&0x3|0x8);
    return v.toString(16);
  }).toUpperCase();
}

module.exports = guid;



//////////////////
// WEBPACK FOOTER
// ./~/simple-guid/lib/guid.js
// module id = 43
// module chunks = 0